export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1e9a26e80366b3046224d41897926515072c2182&name=fetchTypeahead!'